import React from "react";
import { Avatar, Box, Button, Modal, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import BtnSecondary from "../../../../application/components/Button/BtnSecondary";
import { makeStyles } from "@mui/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: 300,
    md: 900,
  },
  bgcolor: "background.paper",
  boxShadow: 0,
  p: 4,
  maxHeight: "80vh",
  overflowY: "auto",
  borderRadius: "8px",
};
const useStyles = makeStyles(() => ({
  root: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
        borderColor: "#98A2B3", // Add black border on hover
      },
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #98A2B3",
      borderRadius: "8px", // Add border radius to the TextField when focused
    },
  },
}));

export default function ProfileUpdateModal({ onClose }) {
  const [open] = React.useState(true);
  const [gender, setGender] = React.useState("male");
  const classes = useStyles();

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleClick = () => {};

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <form>
          <div className="flex justify-between items-center">
            <p className="font-[700] md:text-2xl font-[inter]">
              Please complete your profile, fill out the empty fields.
            </p>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={onClose}
              className="cursor-pointer"
            >
              <path
                d="M27.5459 25.954C27.7572 26.1653 27.876 26.452 27.876 26.7509C27.876 27.0497 27.7572 27.3364 27.5459 27.5477C27.3346 27.7591 27.0479 27.8778 26.749 27.8778C26.4501 27.8778 26.1635 27.7591 25.9521 27.5477L20 21.5937L14.0459 27.5459C13.8346 27.7572 13.5479 27.8759 13.249 27.8759C12.9501 27.8759 12.6635 27.7572 12.4521 27.5459C12.2408 27.3345 12.1221 27.0479 12.1221 26.749C12.1221 26.4501 12.2408 26.1635 12.4521 25.9521L18.4062 19.9999L12.454 14.0459C12.2427 13.8345 12.1239 13.5479 12.1239 13.249C12.1239 12.9501 12.2427 12.6635 12.454 12.4521C12.6654 12.2408 12.952 12.122 13.2509 12.122C13.5498 12.122 13.8364 12.2408 14.0478 12.4521L20 18.4062L25.954 12.4512C26.1654 12.2398 26.452 12.1211 26.7509 12.1211C27.0498 12.1211 27.3364 12.2398 27.5478 12.4512C27.7591 12.6625 27.8778 12.9492 27.8778 13.248C27.8778 13.5469 27.7591 13.8336 27.5478 14.0449L21.5937 19.9999L27.5459 25.954Z"
                fill="#292727"
              />
              <rect
                x="0.5"
                y="0.5"
                width="39"
                height="39"
                rx="7.5"
                stroke="#98A2B3"
              />
            </svg>
          </div>
          <section className="mt-4">
            <div className="flex items-center flex-col md:flex-row gap-4">
              <Avatar
                alt="Remy Sharp"
                src="https://i.pravatar.cc/300"
                sx={{ width: 150, height: 150, border: "1px solid #1E87FF" }}
              />
              <BtnSecondary
                variant="contained"
                size="large"
                text="Upload Image"
                height="56px"
              ></BtnSecondary>
            </div>
          </section>

          <section className="mt-8">
            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Last name
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                First name
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Address
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Phone number
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Email Address
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
                type="email"
              />
            </div>

            <div className="mt-4 w-full">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Date of birth
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker className={`w-full ${classes.root}`} />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Location
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Gender
              </p>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={gender}
                onChange={handleGenderChange}
                className={`w-full ${classes.root}`}
              >
                <MenuItem value={"male"}>Male</MenuItem>
                <MenuItem value={"female"}>Female</MenuItem>
              </Select>
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Next of kin name
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Next of kin relationship
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Next of kin phone
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Marital status
              </p>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="mt-4">
              <p className="font-semibold mb-2 text-[12px] text-[#98A2B3]">
                Bio
              </p>
              <TextField
                id="filled-multiline-static"
                variant="outlined"
                multiline
                rows={4}
                className={`w-full ${classes.root}`}
              />
            </div>

            <div className="flex justify-end mt-4 profile">
              <Button
                variant="contained"
                size="large"
                onClick={handleClick}
                className="py-5"
                style={{ boxShadow: "none" }}
              >
                Save Changes
              </Button>
            </div>
          </section>
        </form>
      </Box>
    </Modal>
  );
}
